import React from 'react';

const Step2 = ({ 
  formData, 
  handleChange
}) => {
  const { 
    organizacionNombre, 
    organizacionRFC, 
    organizacionTipoEntidad, 
    organizacionDireccion, 
    organizacionEstado, 
    organizacionPais, 
    organizacionTelefono 
  } = formData;

  return (
    <>
      {/* SECCION 1: INFORMACIÓN GENERAL */}
      <div className="mb-4">
        <h6 className="fw-bold mb-3 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-building me-2" style={{ color: '#4a6502' }}></i> Información General
        </h6>
        <div className="row">
          <div className="col-md-12 mb-3">
            <label className="form-label fw-bold">Nombre de la Organización <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text">
                <i className="fa fa-building"></i>
              </span>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="Ej. Cooperativa Lxs Peluzos" 
                name="organizacionNombre" 
                value={organizacionNombre || ''} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">RFC / ID Fiscal <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text">
                <i className="fa fa-id-card"></i>
              </span>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="ABC000000XXX" 
                name="organizacionRFC" 
                value={organizacionRFC || ''} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Tipo de Entidad <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text">
                <i className="fa fa-list"></i>
              </span>
              <select 
                className="form-control form-control-sm form-select" 
                name="organizacionTipoEntidad" 
                value={organizacionTipoEntidad || ''} 
                onChange={handleChange} 
                required
              >
                <option value="">Selecciona una opción</option>
                <option value="cooperativa">Cooperativa</option>
                <option value="empresa">Empresa</option>
                <option value="asociacion">Asociación</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* SECCION 2: UBICACIÓN Y CONTACTO */}
      <div className="mb-4">
        <h6 className="fw-bold mb-3 mt-4 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-map-marker-alt me-2" style={{ color: '#4a6502' }}></i> Ubicación y Contacto
        </h6>
        <div className="row">
          <div className="col-md-12 mb-3">
            <label className="form-label fw-bold">Dirección <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text">
                <i className="fa fa-map-marker-alt"></i>
              </span>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="Calle, Número, Colonia" 
                name="organizacionDireccion" 
                value={organizacionDireccion || ''} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>
          <div className="col-md-12 mb-3">
            <label className="form-label fw-bold">Estado / Provincia <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text">
                <i className="fa fa-map"></i>
              </span>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="Ej. Chiapas" 
                name="organizacionEstado" 
                value={organizacionEstado || ''} 
                onChange={handleChange} 
                required 
              />
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">País <span className="text-danger">*</span></label>
            <div className="input-group m-b-15">
              <span className="input-group-text">
                <i className="fa fa-globe"></i>
              </span>
              <select 
                className="form-select form-control form-control-sm" 
                name="organizacionPais" 
                value={organizacionPais || 'mexico'} 
                onChange={handleChange} 
                required
              >
                <option value="mexico">México</option>
              </select>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label fw-bold">Teléfono</label>
            <div className="input-group m-b-15">
              <span className="input-group-text">
                <i className="fa fa-phone"></i>
              </span>
              <input 
                type="tel" 
                className="form-control form-control-lg" 
                placeholder="+52 000 000 0000" 
                name="organizacionTelefono" 
                value={organizacionTelefono || ''} 
                onChange={handleChange} 
              />
            </div>
          </div>
        </div>
      </div>

      {/* SECCION 3: LOGOTIPO */}
      <div className="mb-4">
        <h6 className="fw-bold mb-1 mt-4 d-flex align-items-center text-uppercase" style={{ color: '#8c98a4', fontSize: '0.85rem', letterSpacing: '1px' }}>
          <i className="fa fa-image me-2" style={{ color: '#4a6502' }}></i> Logotipo
        </h6>
        <p className="text-muted mb-3" style={{ fontSize: '0.8rem' }}>(Opcional) Puedes omitir este paso y compartirlo con nosotros más adelante.</p>
        
        <div className="border rounded d-flex flex-column align-items-center justify-content-center py-4 bg-light" style={{ borderStyle: 'dashed !important', cursor: 'pointer', borderColor: '#dee2e6' }}>
            <i className="fa fa-cloud-upload-alt fs-2 mb-2 text-muted"></i>
            <span className="text-muted">Seleccionar imagen</span>
        </div>
      </div>
    </>
  );
};

export default Step2;
